export default {
  private: true,
  template_name: 'Flex',
  allowed_types: [
    'gh_float',
    'gh_dropdown'
  ],
  model: {
    template_id: 'gh_flex',
    name: '',
    icon_id: '',
    class: 'gh_flex gh_col_height_0 gh_height_percent',
    priority: 0,
    container_id: 0,
    content: []
  },
  html:
    '<div class="gh_flex_block">' +
      '<div class="gh_flex_block_list" ng-init="lists = item.content">' +
        '<div class="gh_flex_block_list_item" ng-class="item.class" ng-repeat="item in lists"' +
        'ng-include="item.template_id + \'_editor_light\'"></div>' +
      '</div>' +
    '</div>',
  icon: ''
};
